import { ReactNode } from "react";
import { Link } from "react-router-dom";

import AddIcon from "@mui/icons-material/AddCircleRounded";
import ShowAllIcon from "@mui/icons-material/FormatListBulletedRounded";
import { Box, IconButton } from "@mui/material";

import { EllipsisText } from "@/common/components/ellipsis-text/EllipsisText";
import { AppRoutes } from "@/router/AppRoutes";
import { useTranslation } from "@/translations";

import { CalendarNavigation } from "./components/navigation/CalendarNavigation";

interface Props {
  title: string;
  onPrevClick: () => void;
  onNextClick: () => void;
  onTodayClick: () => void;
  onCreateClick?: () => void;
  customHeaderFilter?: ReactNode;
}

export function ListCalendarHeader({
  title,
  onPrevClick,
  onNextClick,
  onTodayClick,
  onCreateClick,
  customHeaderFilter,
}: Props) {
  const { t } = useTranslation();
  return (
    <Box
      role="toolbar"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      py={0.5}
      px={2}
      bgcolor="fsw.blue-5"
      gap={2}
      aria-label={t("calendar.calendarHeader")}
    >
      <Box display={"flex"} alignItems="center" gap={2} minWidth={0}>
        <Box minWidth={0}>
          <EllipsisText value={title} variant="h6" />
        </Box>
        <CalendarNavigation
          onPrevClick={onPrevClick}
          onNextClick={onNextClick}
          onTodayClick={onTodayClick}
          previousLabel={t("calendar.previousDay")}
          nextLabel={t("calendar.nextDay")}
        />
      </Box>

      <Box display={"flex"} alignItems="center" gap={1} flexShrink={0}>
        {customHeaderFilter}
        <IconButton aria-label={t("calendar.openAppointmentView")} component={Link} to={AppRoutes.Appointments}>
          <ShowAllIcon />
        </IconButton>
        {onCreateClick && (
          <IconButton onClick={onCreateClick} aria-label={t("calendar.createAppointment")}>
            <AddIcon />
          </IconButton>
        )}
      </Box>
    </Box>
  );
}
